/** Fields managed by synchronisation, presentation or server save responses. */
const ignoredFields = new Set([
  "comments",
  "relationships",
  "isLocked",
  "contentProps",
  "coreTrafficLight",
  "history",
  "saved",
  "changed",
  "inError",
  "updatedAt",
  "updatedBy",
  "tocMinorVersion",
  "studyStandardsDate",
]);

/**
 * Identifies derived metadata without interpreting arbitrary variant catalogue keys or values.
 *
 * @param segments - Decoded JSON pointer segments for an editable-data property.
 * @param excludedFields - Metadata names omitted for this comparison, defaulting to history exclusions.
 * @returns Whether the property belongs to metadata outside a variant patch catalogue.
 */
export const isEditableMetadataPath = (
  segments: string[],
  excludedFields: ReadonlySet<string> = ignoredFields,
): boolean => {
  const catalogueIndex = segments.indexOf("allVariantPatches");
  const domainSegments = catalogueIndex < 0 ? segments : segments.slice(0, catalogueIndex);
  const isDiscussionComments =
    (domainSegments[0] === "tlfData" && domainSegments[1] === "comments") ||
    (domainSegments[0] === "hierarchy" && domainSegments[1] === "comments") ||
    (domainSegments[0] === "hierarchyNodes" && domainSegments[2] === "comments");
  return (
    (excludedFields.has("comments") && isDiscussionComments) ||
    domainSegments.some((segment) => segment !== "comments" && excludedFields.has(segment))
  );
};
